import React, { useEffect } from "react";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Swal from "sweetalert2";
import swal from "sweetalert";

const initialFormData = {
  ticket_category_type: "",
  medal_type: "",
};

function DiscountModal({
  showTicketModal,
  handleCloseTicketModal,
  fetchAllTicketData,
  currentpage,
  reapplyDisable,
  playerTypeReApply,
  medalReApply,
  reApplyId,
  remarkReApply,
}) {
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [fileUrl, setFileUrl] = React.useState(null);
  const [formData, setformData] = React.useState(initialFormData);
  const [isLoading, setIsLoading] = React.useState(false);

  const BASE_URL = process.env.REACT_APP_BOOKING_BASE_URL;
  const TOKEN =
    localStorage.getItem("access_token") ||
    localStorage.getItem("access_token_admin");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataConstructor = new FormData();

    // 🔹 If NOT reapplying, validate fields and append them
    if (!reapplyDisable) {
      if (!formData.ticket_category_type || !formData.medal_type) {
        swal("Error", "Please fill all required fields", "error");
        return;
      }

      formDataConstructor.append(
        "athlete_level",
        formData.ticket_category_type
      );
      formDataConstructor.append("medal_type", formData.medal_type);
    }

    // 🔹 Common: attach file if present
    if (selectedFile) {
      formDataConstructor.append("file", selectedFile);
    }

    try {
      setIsLoading(true);

      let response;

      // 🔹 If reapplyDisable is TRUE → call UPDATE API
      if (reapplyDisable) {
        response = await axios.post(
          `${BASE_URL}/api/auth/discount/update/${reApplyId}`,
          formDataConstructor,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: TOKEN,
              Accept: "application/json",
            },
          }
        );
      } else {
        // 🔹 Otherwise → call APPLY API
        response = await axios.post(
          `${BASE_URL}/api/auth/discount/apply`,
          formDataConstructor,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: TOKEN,
              Accept: "application/json",
            },
          }
        );
      }

      // 🔹 Success message
      Swal.fire(
        "Success",
        response?.data?.message || "Operation successful!",
        "success"
      );

      // 🔹 Reset form and refresh
      setformData(initialFormData);
      setSelectedFile(null);
      setFileUrl(null);
      handleCloseTicketModal();
      fetchAllTicketData({ page: currentpage });
    } catch (error) {
      console.error(error);
      swal(
        "Error",
        error?.response?.data?.message || "API request failed",
        "error"
      );
    } finally {
      setIsLoading(false);
      setformData(initialFormData);
    }
  };
  useEffect(() => {
    if (!showTicketModal) {
      // reset file states when modal closes
      setSelectedFile(null);
      setFileUrl(null);
      setformData(initialFormData);
    }
  }, [showTicketModal]);

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      const allowedExtensions = /(\.jpg|\.jpeg|\.webp|\.png|\.pdf)$/i;
      const maxFileSize = 10 * 1024 * 1024;

      if (!allowedExtensions.test(file.name)) {
        swal(
          "Error",
          "Invalid file type. Only jpg, jpeg, webp, png, and pdf allowed.",
          "error"
        );
        setSelectedFile(null);
        setFileUrl(null);
        return;
      }

      if (file.size > maxFileSize) {
        swal("Error", "File size should be less than 10 MB.", "error");
        setSelectedFile(null);
        setFileUrl(null);
        return;
      }

      setSelectedFile(file);
      setFileUrl(URL.createObjectURL(file));
      swal("", "File is selected", "success");
    } else {
      setSelectedFile(null);
      setFileUrl(null);
    }
  };

  const handleFilePreview = () => {
    if (fileUrl) {
      window.open(fileUrl, "_blank");
    }
  };

  const handleChangeInputValue = (e) => {
    const { name, value } = e.target;
    setformData({ ...formData, [name]: value.trimStart() });
  };

  return (
    <Modal show={showTicketModal} onHide={handleCloseTicketModal}>
      <form onSubmit={handleSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">Apply For Discount</h4>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseTicketModal}
          ></button>
        </div>

        <div className="modal-body">
          <div className="add-contact-box">
            <div className="add-contact-content">
              <div className="d-flex gap-3">
                {/* ✅ UPDATED DROPDOWN */}
                <div className="form-group mb-3 flex-fill">
                  <label className="text-black font-w500">
                    Player Type <span className="text-danger">*</span>
                  </label>
                  <Form.Select
                    required
                    value={
                      reapplyDisable
                        ? playerTypeReApply
                        : formData.ticket_category_type
                    }
                    name="ticket_category_type"
                    onChange={handleChangeInputValue}
                    disabled={reapplyDisable}
                  >
                    <option value="">Select Player Type</option>
                    <option value="International Player">
                      International Player
                    </option>
                    <option value="National Player">National Player</option>
                    <option value="State Player">State Player</option>
                  </Form.Select>
                </div>

                <div className="form-group mb-3 flex-fill">
                  <label className="text-black font-w500">
                    Select Medal <span className="text-danger">*</span>
                  </label>
                  <Form.Select
                    required
                    value={reapplyDisable ? medalReApply : formData.medal_type}
                    name="medal_type"
                    onChange={handleChangeInputValue}
                    disabled={reapplyDisable}
                  >
                    <option value="">Select Medal</option>
                    <option value="Gold">Gold</option>
                    <option value="Silver">Silver</option>
                    <option value="Bronze">Bronze</option>
                  </Form.Select>
                </div>
              </div>

              <div className="row">
                <div className="form-group mb-3 col-md-12">
                  <Form.Group controlId="formFile">
                    <Form.Label className="text-black font-w500">
                      Upload Document
                    </Form.Label>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <Button
                        variant="primary"
                        className="ms-2"
                        disabled={!selectedFile}
                        onClick={handleFilePreview}
                      >
                        Preview
                      </Button>
                    </div>
                  </Form.Group>
                </div>
              </div>

              <div>
                {reapplyDisable && (
                  <p>
                    <strong>Remark:</strong> {remarkReApply}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer d-flex justify-content-between">
          <div className="d-flex justify-content-end w-100">
            <button
              type="button"
              className="btn btn-secondary mx-2"
              onClick={handleCloseTicketModal}
            >
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary mx-2"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </>
              ) : reapplyDisable ? (
                "Re Apply"
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default React.memo(DiscountModal);
